import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { departmentsOptionsConstant, personsOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';

import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { SelectValue, Department } from 'src/app/models/common';
import { Users} from 'src/app/models/um/organization';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-um-department-view-modal',
  templateUrl: './um-department-view-modal.component.html',
  styleUrls: ['./um-department-view-modal.component.scss']
})
export class UmDepartmentViewModalComponent implements OnInit {

  formFields;
  //departments = departmentsOptionsConstant;
  persons = personsOptionsConstant;
  departments: any[] = [];
  users: Users[] = [];
  isautocode: boolean = false;
  isautocodeDisabled = "disabled";
  deptForm = new UntypedFormGroup({
    ID: new UntypedFormControl(null),
    CODE: new UntypedFormControl("", [Validators.required, Validators.maxLength(25)]),
    NAME: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
    PARENT_ID: new UntypedFormControl(null),
    INCHARGE_ID: new UntypedFormControl(null),
    DESCRIPTION: new UntypedFormControl(null),
    BREAK_DOWN_STRUCTURE: new UntypedFormControl(null),
    RECORD_STATE: new UntypedFormControl(true)
  });
@Input() public Content: any;
  content:any;
  heading:string;
  action: Subject<any> = new Subject();


  constructor(
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private userService: UserService

  ) {

  }

  ngOnInit() {
    this.departments = [];
    this.users = [];
    if (this.Content?.content && this.Content?.content?.id) { // Edit mode
      this.summaryService.getSummaryData('api/department/getdepartmentbyid/' + this.Content?.content?.id).subscribe((result) => {
        this.setForm(result);
      });
    }
    this.getDepartments();
    this.getUsers();
  }

  
  private setForm(result:any): void {
    this.deptForm = new UntypedFormGroup({
      ID: new UntypedFormControl(result.ID),
      CODE: new UntypedFormControl(result.CODE, [Validators.required, Validators.maxLength(25)]),
      NAME: new UntypedFormControl(result.NAME, [Validators.required, Validators.maxLength(100)]),
      PARENT_ID: new UntypedFormControl(result.PARENT_ID),
      INCHARGE_ID: new UntypedFormControl(result.INCHARGE_ID),
      DESCRIPTION: new UntypedFormControl(result.DESCRIPTION),
      BREAK_DOWN_STRUCTURE: new UntypedFormControl(result.BREAK_DOWN_STRUCTURE),
      RECORD_STATE:new UntypedFormControl(result.RECORD_STATE)
    });
  }

  getDepartments(): void {
    let AssociatedId = '-1';
    if(this.Content && this.Content?.content!=null){
      AssociatedId = this.Content?.content?.AssociatedId;
    }
    this.summaryService.GetDept('api/department/GetDept/'+AssociatedId).subscribe(summary => {
      if (this.Content?.heading === 'Add')
        this.departments = summary;
      else {
        let len = summary;
        this.departments= len.filter((item)=>{
          return item["value"]!=this.Content?.content?.id;
        });
        //this.departments = summary;
      }
      this.departments= [{label:"select",value:"", checked: true}].concat(this.departments);
    });
  }

  getUsers(): void {
    this.summaryService.getUsers('api/appuser/getdeptusers/I').subscribe(summary => {
      this.users = summary;
    });
  }

  save() {
    if (this.validateControls()) {
      var formDt=this.deptForm.value;
      formDt.RECORD_STATE=this.deptForm.controls["RECORD_STATE"].value?1:0;
      formDt.NAME=formDt.NAME==null?null:formDt.NAME==undefined?undefined:formDt.NAME.trim();
      if (!this.Content?.content && this.Content?.heading === 'Add') {
        this.summaryService.Insert('api/department/insert', this.deptForm.value).subscribe(result => {
          if (result.Status === 0) {
            this.commonservice.SuccessBanner(result.Message);
            
            this.modalRef.close();
          }
          else {
            this.commonservice.ValidationBanner(result.Message);
          }
        })
        
      }else if(this.Content?.content && this.Content?.content.id && this.Content?.heading === 'Edit'){
        this.summaryService.Insert('api/department/update', this.deptForm.value).subscribe(result=>{
          if (result.Status === 0) {
           this.commonservice.SuccessBanner(result.Message);
           
            this.modalRef.close();
          }
          else {
            this.commonservice.ValidationBanner(result.Message);
          }
        })
      }      
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.deptForm.value;

    if (formData.NAME === null || formData.NAME === "" || formData== undefined) {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Department Name";
      isValid = false;
    }else if((formData.NAME != null || formData.NAME != undefined)&&(formData.NAME.trim()==="")) {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Department Name";
      isValid = false;
    }
    else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }


    if (!isValid)
      this.commonservice.ValidationBanner(message);

    return isValid;
  }
}
